module.exports = __webpack_public_path__ + "assets/img/18_277.8e41adb5.jpg";